import { readTeantConfiguration } from '@msdk/definitions'
import { useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'

import { $idTaggingEnabled } from './atom'

type WindowWithIdTagging = typeof window & { idTaggingEnabled: boolean }

export function useToggleIDTagging() {
  const [isEnabled, setIsEnabled] = useRecoilState($idTaggingEnabled)
  const { allowIDTagging } = readTeantConfiguration()

  const onKeyDown = (e: KeyboardEvent) => {
    const shouldEnable = e.ctrlKey && e.altKey && e.code === 'KeyT'
    const shouldDisable = e.ctrlKey && e.altKey && e.code === 'KeyQ'

    if (!allowIDTagging) {
      return
    }
    if (shouldEnable) {
      setIsEnabled(true)
    }
    if (shouldDisable) {
      setIsEnabled(false)
    }
  }

  useEffect(() => {
    if (!allowIDTagging) {
      return
    }
    document.documentElement.dataset.idTaggingEnabled = JSON.stringify(isEnabled)
    ;(window as WindowWithIdTagging).idTaggingEnabled = isEnabled
  }, [isEnabled, allowIDTagging])

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown)

    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [])
}

export function useIDTagging() {
  return useRecoilValue($idTaggingEnabled)
}

export function createIDTagging(msName?: string, sectionName?: string, idml?: string) {
  return `{${msName}-${sectionName}-${idml}}`
}
